import { CssBaseline, ThemeProvider } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { ApiError } from "./api/client";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthContext";
import { theme } from "./theme";

const kolejka = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Panel jest narzędziem do wpisywania, nie do oglądania: odświeżenie
      // przy powrocie do okna potrafiłoby wejść w środek edycji.
      refetchOnWindowFocus: false,
      // Odmowa dostępu nie naprawi się przez powtórzenie — powtarzamy tylko
      // to, co mogło paść z powodu sieci.
      retry: (proba, blad) =>
        !(blad instanceof ApiError && blad.isUnauthorized) && proba < 2,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={kolejka}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
